'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MastheadExtensionWidgets = undefined;

var _themeProvider = require('@spp/theme-provider');

var _MastheadExtensionWidgets = require('./MastheadExtensionWidgets');

var _MastheadExtensionWidgets2 = _interopRequireDefault(_MastheadExtensionWidgets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.MastheadExtensionWidgets = _MastheadExtensionWidgets2.default;
exports.default = (0, _themeProvider.themer)('@spp/cn-masthead-extension-widgets')(_MastheadExtensionWidgets2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/MastheadExtensionWidgets/index.js
 ** module id = 613
 ** module chunks = 1
 **/